<template>
    <div>  <!-- wrapped in div so classes on root will go here -->
        <b-form-file 
            ref="file-input"
            :accept="accept"
            :multiple="multiple" 
            :directory="directory"
            no-traverse
            :disabled="disabled"
            @input="handleInput"
            class="file-dropper-component"
            :class="[disabled ? 'file-dropper-disabled' : 'file-dropper-active']"
            :style="{height: localInputHeight}"
        >
            <template #placeholder>
                <div class="w-100">
                    <div v-if="!disabled" class="text-center">
                        <b-icon :icon="imageMode ? 'images' : 'cloud-upload'" font-scale="3"></b-icon>
                    </div>
                    <div class="text-center mt-2">
                        {{ localPlaceholderText }}
                    </div>
                </div>
            </template>
            <template #drop-placeholder>
                <div class="w-100">
                    <div v-if="!disabled" class="text-center">
                        <b-icon icon="arrow-down-circle" font-scale="3"></b-icon>
                    </div>
                    <div class="text-center mt-2">
                        {{ localDropText }}
                    </div>
                </div>
            </template>
        </b-form-file>
    </div>
</template>

<script>
// import { defaultImageAcceptString } from './file_slinger_helpers';
// DO NOT DO ANY ACTUAL UPLOADING HERE -- EMIT TO PARENT AND LET PARENT HANDLE IT
// parent may need to handle new files and existing files in some way, so makes sense there

// THIS IS ONLY FOR DROPPING NEW FILES -- immediately sends them up to parent and resets itself
// so this DOES NOT HOLD A VALUE, and DOES NOT ACCEPT VALUE FROM PARENT
// but it DOES emit 'input' event when new things are dropped on it

export default {
    components: { 
        //BIconArrowDownCircle,
        //BIconCloudUpload 
    },
    props: {
        /* value: {  // will be File objects? this is the v-model to the input
            // NOT USING THIS - THIS IS ONLY FOR DROPPING (ADDING NEW) FILES
            required: false,
        }, */
        multiple: {
            type: Boolean,
            default: false,
        },
        directory: {  // allows dropping in entire directory -- use no-traverse to make it return a flat list of files -- MAY NOT BE FULLY SUPPORTED BY ALL BROWSERS
            type: Boolean,
            default: false,
        },
        inputHeight: { // string of some valid height - '200px', '10rem', etc.
            type: String,
            default: '200px',
        },
        placeholderText: {
            type: String,
            required: false,  // have default in computed 
        },
        dropText: {
            type: String,
            required: false,  // have default in computed
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        disabledPlaceholderText: {
            type: String,
            required: false,  // have default in computed 
        },
        disabledDropText: {
            type: String,  // default in computed 
            required: false,  
        },
        disabledInputHeight: {
            type: String,
            default: '60px',
        },
        accept: {  // string of comma-separated mime-types or .extensions - HTML standard 
            type: String,
            default: '',  // we have default in the parent component instead
        },
        imageMode: {  // set true to DISPLAY THINGS FOR IMAGE UPLOADS - does not control accept string, just formatting of things
            type: Boolean,
            default: false,
        },
    },
    computed: {
        localPlaceholderText() {
            const activeDefault = `Drop${ this.imageMode ? ' Image' : ''} File${this.multiple ? 's' : ''} Here -or- Click to Select`;  // putting default here so we can check plural
            const disabledDefault = `No File${this.multiple ? 's' : ''}`;
            return this.disabled ? (this.disabledPlaceholderText || disabledDefault) : (this.placeholderText || activeDefault);
        },
        localDropText() {
            const activeDefault = `Drop Here`;
            const disabledDefault = `Not Allowed`;
            return this.disabled ? (this.disabledDropText || disabledDefault) : (this.dropText || activeDefault);
        },
        localInputHeight() {
            return this.disabled ? this.disabledInputHeight : this.inputHeight;
        },
    },
    methods: {
        handleInput(payload) {
            // just emit 'input' to parent because this is v-model
            // payload will be a single File object in single mode or an array of File objects in multiple mode
            // but check for null first... because this gets triggered again when you call .reset() on the input below
            if (!payload) return;
            // NOV 16 2022 - we will NORMALIZE this to ALWAYS emit an ARRAY, even for single-file mode - parent expects it, easier that way
            const payloadArray = Array.isArray(payload) ? payload : [payload];
            this.$emit('input', payloadArray);
            // clear the files in file input using .reset() (use a ref)
            // or by setting v-model to [] for multiple mode, or null for single mode.  (normally v-model for file input is unidirectional)
            this.$refs['file-input'].reset()
        },
    }
}
</script>

<style lang="scss">
// not sure why scoped does not work here... but because we have scss scoped, we should be OK

.file-dropper-component {
    // height is set on this
    label.custom-file-label {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-style: dashed;
        background-color: $primary-50;
        span.form-file-text {
            font-weight: 500;
            //text-transform: uppercase;
            color: $gray-400;
        }
        &::after {
            // this is the button
            display: none;
        }
    }
    &.file-dropper-active {  // only change styles when NOT disabled 
        label.custom-file-label {
            &.dragging {
                // when dragging and over the input .dragging is added to label element
                background-color: $success-50;
                border-style: solid;
                border-color: $success;
                border-width: 3px;
            }
        }
    }
    &.file-dropper-disabled {
        label.custom-file-label {
            // defaults are mostly OK
            border-style: none;
        }
    }
}

</style>